import debounce from "lodash/debounce";

export default {
  props: {
    label: {
      type: String,
      default: "Label Text"
    },
    hint: {
      type: String,
      default: "Hint Text"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    question: {
      type: Object,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  beforeDestroy() {
    if (this.question && this.question.expressions) {
      this.question.expressions.forEach(expression => {
        this.$set(expression, "satisfied", false);
      });
    }
    if (this.question) {
      switch (this.question.displayType) {
        case "RADIO":
        case "FILE":
        case "CHECKBOX":
        case "DROPDOWN":
        case "DISPLAY_TEXT":
        case "SIGNATURE":
          this.question.value = null;
          break;
        case "TEXT":
        case "DATE":
          this.question.value = "";
          break;
        case "ADDRESS":
          this.question.value = {};
          break;
        default:
          break;
      }
    }
  },
  watch: {
    question() {
      if (this.evaluateAllExpressions) this.evaluateAllExpressions();
    },
    "question.value": debounce(function() {
      if (this.evaluateAllExpressions) this.evaluateAllExpressions();
    }, 500)
  },
  created() {
    if (this.evaluateAllExpressions) this.evaluateAllExpressions();
  }
};
